import React, { useLayoutEffect, useRef } from 'react';

/**
 * Bloc-notes partagé : quand le texte change sous les doigts (saisie d'un autre participant fusionnée), le curseur
 * reste au même endroit du texte au lieu de sauter à la fin.
 */
const SharedNotes = ({ value, onChange, placeholder = 'Notes rapides…', className = '' }) => {
  const ref = useRef(null);
  const typed = useRef(value);
  const caret = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    const previous = typed.current;
    typed.current = value;
    if (!el || previous === value || document.activeElement !== el || !caret.current) return;
    // Décalage du curseur : seulement si le changement reçu est avant lui.
    let start = 0;
    const max = Math.min(previous.length, value.length);
    while (start < max && previous[start] === value[start]) start += 1;
    const delta = value.length - previous.length;
    const shift = (pos) => (pos > start ? Math.max(start, pos + delta) : pos);
    el.setSelectionRange(shift(caret.current.start), shift(caret.current.end));
  }, [value]);

  const remember = () => {
    const el = ref.current;
    if (el) caret.current = { start: el.selectionStart, end: el.selectionEnd };
  };

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={(e) => {
        typed.current = e.target.value;
        caret.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
        if (onChange) onChange(e.target.value);
      }}
      onSelect={remember}
      onKeyUp={remember}
      onClick={remember}
      className={`w-full border border-slate-200 rounded-lg px-3 py-2 text-sm min-h-[120px] focus:ring-2 focus:ring-indigo-100 outline-none ${className}`}
      placeholder={placeholder}
    />
  );
};

export default SharedNotes;
